{
  "title": "Campañas",
  "subtitle": "Un banner bajo la firma, entre dos fechas. Configura las fechas y aparece y desaparece solo: nadie tiene que acordarse de quitarlo.",
  "newCampaign": "Nueva campaña",
  "emptyTitle": "Sin campañas",
  "emptyBody": "Una campaña rellena el hueco de banner en una plantilla de firma. Añade el hueco en el diseñador primero, o el banner no tendrá dónde aparecer.",
  "liveNow": "En vivo ahora",
  "noBanner": "Sin banner",
  "statusDraft": "Borrador",
  "statusScheduled": "Programada",
  "statusActive": "Activa",
  "statusRunning": "En curso",
  "statusPaused": "En pausa",
  "statusEnded": "Finalizada",
  "edit": "Editar",
  "pause": "Pausar",
  "resume": "Reanudar",
  "schedule": "Programar",
  "startNow": "Iniciar ahora",
  "end": "Finalizar",
  "delete": "Eliminar",
  "deleteConfirm": "¿Eliminar esta campaña?",
  "name": "Nombre",
  "namePlaceholder": "Roadshow de primavera",
  "starts": "Empieza",
  "ends": "Termina",
  "banner": "Banner",
  "chooseBanner": "Elegir banner",
  "chooseImage": "Elegir una imagen",
  "changeImage": "Cambiar imagen",
  "removeBanner": "Quitar",
  "bannerHint": "Diseña a 600 px de ancho: coincide con el hueco de banner por defecto. La altura es flexible; unos 100 px es habitual. Una campaña sin banner no muestra nada, diga lo que diga su programación.",
  "link": "Enlace",
  "linkDescription": "Adónde va un clic. Se envuelve en una redirección de seguimiento al enviar.",
  "linkPlaceholder": "https://ejemplo.com/oferta",
  "linksTo": "Enlaza a {{url}}",
  "altText": "Texto alternativo",
  "altTextDescription": "Lo leen los lectores de pantalla y lo muestran los clientes que bloquean imágenes — la mayoría por defecto.",
  "timezoneHint": "Las horas están en tu zona horaria local. Deja el final vacío para un banner que corre hasta que alguien lo detenga.",
  "createDraft": "Crear borrador",
  "save": "Guardar",
  "saveCampaign": "Guardar campaña",
  "createTitle": "Nueva campaña",
  "editTitle": "Editar campaña",
  "saved": "Campaña guardada.",
  "createdDraft": "Creada como borrador. Prográmala o iníciala cuando estés listo.",
  "saveError": "No se pudo guardar eso.",
  "deleted": "{{name}} eliminada.",
  "deleteError": "No se pudo eliminar esa campaña.",
  "statusUpdated": "Campaña {{verb}}.",
  "statusError": "No se pudo cambiar eso.",
  "actionsAria": "Acciones para {{name}}",
  "windowNoDates": "Sin fechas: solo se ejecutará si se inicia a mano.",
  "windowFromOpen": "Desde {{starts}}, hasta que alguien la termine.",
  "windowUntil": "Hasta {{ends}}.",
  "windowRange": "{{starts}} a {{ends}}."
}
